export default {
    title: "Cím ellenőrzése",
    header: "@:views.address.verified.title",
    message: "Köszönjük, hogy igazolta a címét. Mostantól ezt is kiválaszthatja szállítási címként a rendelés leadásakor.",
}